import SSIWrapper from '@media-platform/portal-menu/src/components/BurgerBlocks/BurgerMenu/SSIWrapper';
import type { IBurgerMenu } from '@media-platform/portal-menu/src/types';
/* Доп элементы меню (ссылка "Все проекты" обязательна!) */
const subMenuItemsConfig = [
    {
        type: 'link-icon-projects',
        href: 'https://vk.company/ru/projects/',
        text: 'Все проекты',
        target: '_blank',
    },
];
/* Ссылки на соцсети проектов */
const footerSocialItemsConfig = [
    {
        type: 'icon-social',
        alias: 'vk',
        target: '_blank',
        href: 'https://vk.ru/petsmail',
    },
    {
        type: 'icon-social',
        alias: 'ok',
        target: '_blank',
        href: 'https://ok.ru/petsok',
    },
];
/* Ссылки в подвале проекта */
const footerItems = [
    {
        type: 'link-cell',
        text: (<SSIWrapper pathKey="COPYRIGHT" ssi='<!--#include virtual="/mortice/block-copyright/" wait="yes" -->'/>),
    },
    {
        type: 'link-cell',
        href: 'https://pets.mail.ru/editorial-staff/',
        text: 'Редакция',
        target: '_blank',
    },
    {
        type: 'link-cell',
        href: 'https://pets.mail.ru/consultation/all/',
        text: 'Наши эксперты',
        target: '_blank',
    },
    {
        type: 'link-cell',
        href: 'https://help.mail.ru/legal/terms/pets/policy',
        text: 'Условия использования материалов',
        target: '_blank',
    },
    {
        type: 'link-cell',
        href: 'https://help.mail.ru/legal/terms/common/mediarecommendation',
        text: 'О технологиях рекомендаций',
        target: '_blank',
    },
    {
        type: 'link-cell',
        text: 'Политика конфиденциальности',
        href: 'https://help.mail.ru/legal/terms/common/privacy/',
        target: '_blank',
    },
    {
        type: 'link-cell',
        href: 'https://help.mail.ru/pets_support',
        text: 'Обратная связь',
        target: '_blank',
    },
    {
        type: 'link-cell',
        href: 'https://help.mail.ru/pets_support/consultant',
        text: 'Стать консультантом',
        target: '_blank',
    },
];
export function burgerConfigMobile(): IBurgerMenu['burger'] {
    return {
        projectLinks: {
            items: subMenuItemsConfig,
        },
        footer: {
            social: {
                items: footerSocialItemsConfig,
            },
            items: footerItems,
        },
    };
}
